// libraries
import React from 'react'
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import Image from '/react4xp/components/Image'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

interface ByTheNumbersProps {
    bgColor: 'default' | 'green' | 'beige'
    title?: string
    intro?: string
    facts?: Array<{
        icon?: {
            src: string
            alt: string
        }
        value: string
        label: string
    }>
}

export default function ByTheNumbers({
    bgColor,
    title,
    intro,
    facts
}: ByTheNumbersProps) {
    return (
        <Section
            bgColor={clsx(
                bgColor === 'beige' && 'bg-beige-primary-dark',
                bgColor === 'green' && 'bg-green-secondary-dark'
            )}
            textColor='text-dark'
            className='by-the-numbers'
        >
            <div className='grid-container'>

                {(title || intro) && (
                    <div className='by-the-numbers__header'>

                        {isNonWhitespaceString(title) && (
                            <h2 className='title-md title'>
                                {title}
                            </h2>
                        )}

                        {isNonWhitespaceString(intro) && (
                            <div
                                className='text-md intro'
                                dangerouslySetInnerHTML={{ __html: intro }}
                                suppressHydrationWarning
                            />
                        )}

                    </div>
                )}

                {facts && (
                    <div className={clsx(
                        'by-the-numbers__facts',

                        // number of cols
                        facts.length === 1 && 'by-the-numbers__facts--one',
                        facts.length === 2 && 'by-the-numbers__facts--two',
                        facts.length === 3 && 'by-the-numbers__facts--three',
                        facts.length >= 4 && 'by-the-numbers__facts--four',

                        // numbers of cols (with icons)
                        facts.length === 1 && facts[0].icon && 'by-the-numbers__facts--one-with-icon',
                        facts.length === 2 && facts[0].icon && 'by-the-numbers__facts--two-with-icon',
                        facts.length === 3 && facts[0].icon && 'by-the-numbers__facts--three-with-icon',
                        facts.length >= 4 && facts[0].icon && 'by-the-numbers__facts--four-with-icon',
                    )}>
                        {facts.map((item, i) => (
                            <div className='fact__item' key={i}>
                                
                                {item.icon && (
                                    <Image
                                        src={item.icon.src} // 80x80
                                        alt={item.icon.alt}
                                        className='fact__item__icon'
                                    />
                                )}

                                {(item.value || item.label) && (
                                    <div className='fact__item__wrapper'>

                                        {isNonWhitespaceString(item.value) && (
                                            <h3 className='title-lg value'>
                                                {item.value}
                                            </h3>
                                        )}

                                        {isNonWhitespaceString(item.label) && (
                                            <p className='text-md label'>
                                                {item.label}
                                            </p>
                                        )}

                                    </div>
                                )}
                                
                            </div>
                        ))}
                    </div>
                )}

            </div>
        </Section>
    )
}

